module.exports = __webpack_public_path__ + "static/media/estadistica_grafica.27c573a3.svg";